const PERCENTAGE_THRESHOLD = 40;

export enum FlexibleDatesRepricingTrendType {
  notApplicable = 'notApplicable',
  equal = 'equal',
  down = 'down',
  up = 'up',
  highest = 'highest',
}

export const getFlexibleDatesDealTrend = ({
  itinerary,
  flexibleDatesPrice,
}): FlexibleDatesRepricingTrendType => {
  const { price } = itinerary;

  if (!flexibleDatesPrice) return FlexibleDatesRepricingTrendType.notApplicable;

  const diffPrice = price.amount - flexibleDatesPrice;

  let flexibleDatesTrend = FlexibleDatesRepricingTrendType.highest;
  if (Math.abs(diffPrice) < 2) {
    flexibleDatesTrend = FlexibleDatesRepricingTrendType.equal;
  } else if (diffPrice < 0) {
    flexibleDatesTrend = FlexibleDatesRepricingTrendType.down;
  } else if (diffPrice < (flexibleDatesPrice * PERCENTAGE_THRESHOLD) / 100) {
    flexibleDatesTrend = FlexibleDatesRepricingTrendType.up;
  }
  return flexibleDatesTrend;
};
